import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
} from "../../../assets/images/index";

const SpecialOffers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Special Offers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1101"
          img={spfOne}
          productName="Black Pepper"
          price="149"
          color="100gm"
          badge={true}
          des={`Grown in the fertile soils of Idukki, Kerala, our black pepper is bold, aromatic, and packed with natural goodness. Known as the "King of Spices," it brings a sharp, fiery flavor that enhances any dish. At Heritage Harvest, we deliver freshly harvested and carefully processed black pepper to ensure maximum pungency, rich aroma, and authentic taste straight from Kerala’s spice farms.`}
          ogprice="200"
        />
        <Product
          _id="1102"
          img={spfTwo}
          productName="Cardomom"
          price="460"
          color="100gm"
          badge={true}
          des={`Sourced from the misty hills of Idukki, Kerala, our cardamom is handpicked to bring you the purest flavor and aroma. Known as the "Queen of Spices," cardamom adds a rich, refreshing taste to both sweet and savory dishes. Whether for cooking, baking, or brewing a soothing cup of chai, Heritage Harvest cardamom ensures unmatched freshness, natural oils, and authentic Kerala quality.`}
          ogprice="899"
        />
      </div>
    </div>
  );
};

export default SpecialOffers;
